// Restrict searchable English attributes
export const restrictSearchableAttributes = ['_primaryTags_en', '_tags_en', 'name', 'category', 'objectID'];

export const emptyQuery = {
  hits: [],
  nbPages: 0,
  page: 0,
  hitsPerPage: 0,
  nbHits: 0,
  exhaustiveTypo: 0,
  exhaustiveNbHits: 0,
  params: '',
  processingTimeMS: 0,
  query: '',
};

export const emptyIcons8Query = {
  icons: [],
  success: true,
  parameters: {},
};

export const emptyIcons8IllustrationQuery = {
  illustrations: [],
};

// Icons8 illustration icons that will be excluded from search results
export const EXCLUDE_ICONS8_ILLUSTRATION_ICON_IDS = ['6475e5054fd9c17b3580cd15'];
